import React from 'react';
import { useHydrateAtoms } from 'jotai/utils';

import { deviceAtom } from '@/atoms/device';

interface InitializerProps {
  children: React.ReactNode;
  device: 'pc' | 'mo';
}

const Initializer: React.FC<InitializerProps> = ({ children, device }) => {
  useHydrateAtoms([[deviceAtom, device]], { dangerouslyForceHydrate: true });

  return <>{children}</>;
};

export default Initializer;
